// noinspection JSUnusedGlobalSymbols

import HomePage from '@/home/views/HomePage';
import { article, ParamArticle } from '@/article/views/Article';
import AppDownload from '@/appdownload/views/AppDownload';
import Contact from '@/contactUs/views/Contact';
import TicketCheck from '@/ticketcheck/views/TicketCheck';
import AccountMessages from '@/message/views/AccountMessages';
import AccountMessage from '@/message/views/AccountMessage';
import NikeOneVirtual from '@/nikeone/views/NikeOneVirtual';
import Logout from '@/logout/views/Logout';
import Reklamacia from '@/reklamacia/views/Reklamacia';
import FullSearch from '@/fullsearch/views/FullSearch';
import HelpArticles from '@/help/HelpArticles';
import MainMenu from '@/menu/views/MainMenu';
import SuperOfferPage from '@/homesubpages/superoffer/SuperOfferPage';
import Loadable from '@/common/lazy/Loadable';
import { NikeOne } from '@/nikeone/views/NikeOneNg';
import NotificationsPage from '@/notifications/components/pages/LoadableNotificationsPage';
import RecentlyVisitedPage from '@/recentlyvisited/views/RecentlyVisitedPage';
import SelfExclusion from '@/selfExclusion/SelfExclusionLoadable';
import { MyTicketsLoadable } from '@/mytickets/MyTicketsLoadable';
import LegalInformation from '@/legalInformation/LegalInformation';
import imports from './imports';
import TransactionHistory from '@/transactionHistory/views/TransactionHistory';
import ProfileSettings from '@/myprofile/views/settings/ProfileSettings';
import OnbLoader from '@/ui/OnbLoader';
import { LoginPage } from '@/loginng/views/LoginDialog';
import { BonusesMenu, ForPlayersMenu, LawMenu } from 'nike-ui/src/components/menu';
import { ArticleMenu } from '@/article/views/ArticleMenu';
import {
    TURBO_LIVE_FAVORITE_PATH,
    TURBO_LIVE_MATCH_DETAIL_PATH,
    TURBO_LIVE_SPORT_PATH,
    TV_NIKE_ARCHIVE_DETAIL_PATH,
    TV_NIKE_ARCHIVE_OVERVIEW_PATH,
    TV_NIKE_HIGHLIGHTS_DETAIL_PATH,
    TV_NIKE_HIGHLIGHTS_OVERVIEW_PATH,
    TV_NIKE_STREAM_DETAIL_PATH,
    TV_NIKE_STREAM_OVERVIEW_PATH
} from 'nike-ui/src/common/routing';
import * as React from 'react';
import ChangePhoneNumber from '@/changePhoneNumber/views/ChangePhoneNumber';
import AccountCancelRequest from '@/account/views/AccountCancelRequest';
import {
    PROMO_CMS_BETS_PATH,
    PROMO_CMS_ROOT_PATH,
    PROMO_CMS_SCHEDULE_PATH,
    PROMO_CMS_TABLES_PATH
} from 'nike-ui/src/components/promo-cms/constants';
import {
    CASINO_ARTICLE_PATH,
    CASINO_CATEGORY_PATH,
    CASINO_GAME_DESCRIPTION_PATH,
    CASINO_GAME_PLAY_PATH,
    CASINO_HISTORY_PATH,
    CASINO_HRY_CATEGORY_PATH,
    CASINO_HRY_LOBBY_PATH,
    CASINO_KASINO_CATEGORY_PATH,
    CASINO_KASINO_LOBBY_PATH,
    SCRATCHCARDS_HISTORY_PATH
} from 'nike-ui/src/components/casino/paths';
import { RequiresNikeone } from 'nike-ui/src/components/nikeone/RequiresNikeone';
import { ModuleFallback } from '@/common/components/ModuleFallback';
import { SCRATCHCARD_PATHS } from 'nike-ui/src/components/lottery/paths';
import { ARTICLE_ARCHIVE_PATHS } from 'nike-ui/src/components/article-archive/paths';
import { COMMUNITY_PATHS } from 'nike-ui/src/components/betbook/paths';
import { GOAL_OF_MONTH_PATHS } from 'nike-ui/src/components/goal-of-month/paths';

const RegistrationRoot = Loadable({ loader: imports.profile, loading: OnbLoader, exp: Exp => Exp.RegistrationRoot });
const OnbPostRegistration = Loadable({
    loader: imports.profile,
    loading: OnbLoader,
    exp: Exp => Exp.OnbPostRegistration
});

const ResetPassword = Loadable({ loader: imports.profile, exp: Exp => Exp.ResetPassword });
const MyProfile = Loadable({ loader: imports.profile, exp: Exp => Exp.MyProfile });
const PairedDevices = Loadable({ loader: imports.profile, exp: Exp => Exp.PairedDevices });

const MyMoney = {
    Vklad: Loadable({ loader: imports.money, exp: Exp => Exp.Vklad }),
    Prevody: Loadable({ loader: imports.money, exp: Exp => Exp.Prevody }),
    Vyber: Loadable({ loader: imports.money, exp: Exp => Exp.Vyber }),
    MoneyDepositDoneSuccess: Loadable({ loader: imports.money, exp: Exp => Exp.MoneyDepositDoneSuccess }),
    MoneyDepositDoneFail: Loadable({ loader: imports.money, exp: Exp => Exp.MoneyDepositDoneFail }),
    MoneyDepositDoneConflict: Loadable({ loader: imports.money, exp: Exp => Exp.MoneyDepositDoneConflict })
};

const Clubnike = {
    ClubNikeNg: Loadable({ loader: imports.clubNike, exp: Exp => Exp.ClubNikeNg }),
    BringFriends: Loadable({ loader: imports.clubNike, exp: Exp => Exp.BringFriends }),
    ClubNikeDetail: Loadable({ loader: imports.clubNike, exp: Exp => Exp.ClubNikeDetail })
};

const ScratchCards = {
    LotteryTicket: Loadable({ loader: imports.lotteryTicket, exp: Exp => Exp.LotteryTicket }),
    LotteryTicketDetail: Loadable({ loader: imports.lotteryTicket, exp: Exp => Exp.LotteryTicketDetail })
};

const BonusDashboard = {
    Current: Loadable({ loader: imports.bonuses, exp: Exp => Exp.Dashboard.Current }),
    History: Loadable({ loader: imports.bonuses, exp: Exp => Exp.Dashboard.History })
};

const Chat = Loadable({ loader: imports.chat, exp: Exp => Exp.ChatRoot });

const TournamentsRoot = Loadable({ loader: imports.tournaments, exp: Exp => Exp.TournamentsRoot });

/**
 ************************
 * ROUTE ORDER MATTERS! *
 ************************
 */

export const APPLICATION_DOWNLOAD = { path: '/aplikacia', name: 'page::applicationDownload', component: AppDownload };

export const SUPEROFFER = { path: '/tipovanie/superponuka', name: 'page::superoffer', component: SuperOfferPage };

export const TICKET_CHECK = { path: '/kontrola-tiketu', name: 'ticketCheck', component: TicketCheck };

export const NIKE1_TOURNAMENT = { path: '/tipovanie/turnaj/:boxId', name: 'nikeOneTournament', component: NikeOne };
export const NIKE1_MATCH = {
    path: '/tipovanie/zapas/:eventId/:meta?',
    name: 'nikeOneMatch',
    component: NikeOne
};
export const NIKE1_DETAIL = { path: '/tipovanie/zapas-live/:eventId', name: 'nikeOneDetail', component: NikeOne };
export const NIKE1_MENU_ITEM_TOURNAMENT = {
    path: '/tipovanie/:sportSlugPart/:countrySlugPart/:tournamentSlugPart',
    name: 'nikeOneMenuItemTournament',
    component: NikeOne
};
export const NIKE1 = { path: '/tipovanie/:sportSlugPart?/:countrySlugPart?', name: 'nikeOne', component: NikeOne };
export const NIKE1_RESULTS = {
    path: '/vysledky/:sportSlugPart?/:countrySlugPart?',
    name: 'nikeOneResults',
    component: NikeOne
};

export const TRANSACTION_HISTORY = {
    path: '/osobna-zona/historia-transakcii',
    name: 'TransactionHistory',
    component: TransactionHistory
};

export const TOURNAMENTS_RANKING = {
    path: '/turnaje/:tournamentId/rebricek',
    name: 'TournamentRanking',
    component: TournamentsRoot
};
export const TOURNAMENTS_REWARDS = { path: '/turnaje/odmeny', name: 'TournamentRewards', component: TournamentsRoot };
export const TOURNAMENTS_TICKETS = {
    path: '/turnaje/:tournamentId/tikety',
    name: 'TournamentTickets',
    component: TournamentsRoot
};
export const TOURNAMENTS = { path: '/turnaje', name: 'Tournaments', component: TournamentsRoot };
export const TOURNAMENT_ROUTES = [TOURNAMENTS, TOURNAMENTS_REWARDS, TOURNAMENTS_RANKING];

export const VIRTUAL_GAMES = {
    path: '/virtualne-hry/:sportSlugPart?',
    name: 'page::virtualGames',
    component: NikeOneVirtual
};

export const NIKE1_FAV = {
    path: '/favorites/tipovanie/:sportSlugPart?/:countrySlugPart?',
    name: 'page:nikeOneFav',
    component: NikeOne
};
export const FAVORITES_HISTORY = {
    path: '/favorites/historia',
    name: 'page::favoritesHistoria',
    component: RecentlyVisitedPage
};

export const ONB_POST_REGISTRATION = {
    path: '/doregistracia/:pageSlug?',
    name: 'onb_post',
    component: OnbPostRegistration
};

export const REGISTRATION = {
    path: '/registracia/:prospectId?',
    name: 'registration',
    component: RegistrationRoot
};

export const RESET_PASSWORD = { path: '/zabudnute-heslo', name: 'resetPassword', component: ResetPassword };
export const LOGOUT = { path: '/odhlasenie', name: 'logout', component: Logout };

export const SELF_EXCLUSION = { path: '/osobna-zona/sebaobmedzenie', name: 'selfExclusion', component: SelfExclusion };
export const SELF_EXCLUSION_COMMON = {
    path: '/osobna-zona/seba-obmedzenie',
    name: 'selfExclusion',
    component: SelfExclusion
};

export const PAIRED_DEVICES = {
    path: '/osobna-zona/moje-zariadenia',
    name: 'mojezariadenia',
    component: PairedDevices
};
export const ARTICLE_SELF_EXCLUSION = {
    path: '/osobna-zona/seba-obmedzenie-info',
    name: 'article-self-exclusion',
    component: article('self-exclusion-info')
};

export const MY_TICKETS = {
    path: '/osobna-zona/moje-tikety',
    name: 'page::myTicketsOverview',
    component: MyTicketsLoadable
};
export const SAVED_TICKETS = { path: '/ulozene-tikety', name: 'page::savedTickets', component: MyTicketsLoadable };
export const TICKET_DETAIL = { path: '/tiket/:hash', name: 'page::ticketDetail', component: MyTicketsLoadable };
export const TICKET_DETAIL_ALIAS = {
    path: '/tiket-alias/:alias',
    name: 'page::ticketDetailAlias',
    component: MyTicketsLoadable
};
export const MESSAGE = { path: '/osobna-zona/spravy/:spravaId', name: 'page::message', component: AccountMessage };
export const MESSAGES = { path: '/osobna-zona/spravy', name: 'page::messages', component: AccountMessages };

export const ACCOUNT_PROFILE = { path: '/osobna-zona/moj-profil', name: 'accountProfile', component: MyProfile };
export const ACCOUNT_PASSWORD = { path: '/osobna-zona/zmena-hesla', name: 'accountPassword', component: MyProfile };
export const ACCOUNT_GRID = { path: '/osobna-zona/grid-karta', name: 'accountGrid', component: MyProfile };
export const ACCOUNT_SETTINGS = {
    path: '/osobna-zona/nastavenia',
    name: 'accountSettings',
    component: ProfileSettings
};

export const MONEY_DEPOSIT = {
    path: '/osobna-zona/vklad-na-ucet',
    name: 'page::moneyDeposit',
    component: MyMoney.Vklad
};
export const MONEY_WITHDRAWAL = {
    path: '/osobna-zona/vyber-z-uctu',
    name: 'page::moneyWithdrawal',
    component: MyMoney.Vyber
};
export const MONEY_TRANSFER = {
    path: '/osobna-zona/moje-prevody',
    name: 'page::moneyTransfer',
    component: MyMoney.Prevody
};
export const MONEY_DEPOSIT_DONE_SUCCESS = {
    path: '/osobna-zona/prevod-uspesny',
    name: 'page::moneyDepositDoneSuccess',
    component: MyMoney.MoneyDepositDoneSuccess
};
export const MONEY_DEPOSIT_DONE_FAIL = {
    path: '/osobna-zona/prevod-neuspesny',
    name: 'page::moneyDepositDoneFail',
    component: MyMoney.MoneyDepositDoneFail
};
export const MONEY_DEPOSIT_DONE_CONFLICT = {
    path: '/osobna-zona/prevod-konflikt',
    name: 'page::moneyDepositDoneConflict',
    component: MyMoney.MoneyDepositDoneConflict
};
export const MONEY_WITHDRAWAL_VERIF = {
    path: '/osobna-zona/pomoc-s-verifikaciou-uctu',
    name: 'page::moneyWithdrawalVerif',
    component: article('pomoc-s-verifikaciou-bankoveho-uctu')
};
export const MONEY_WITHDRAWAL_NEVERIF = {
    path: '/osobna-zona/chyba-neverifikovany-ucet',
    name: 'page::moneyWithdrawalNeverif',
    component: article('chyba-neverifikovany-bankovy-ucet')
};

export const BONUS_DASHBOARD_CURRENT = {
    path: '/osobna-zona/bonusy-aktualne',
    name: 'bonusDashboardCurrent',
    component: BonusDashboard.Current
};
export const BONUS_DASHBOARD_HISTORY = {
    path: '/osobna-zona/bonusy-historia',
    name: 'bonusDashboardHistory',
    component: BonusDashboard.History
};

export const BRING_FRIENDS = {
    path: '/osobna-zona/dotiahni-kamosov',
    name: 'bringFriends',
    component: Clubnike.BringFriends
};

export const CLUB_NIKE_DETAIL = {
    path: '/klub/:articleUrl',
    name: 'clubnikeDetail',
    component: Clubnike.ClubNikeDetail
};
export const CLUB_NIKE = { path: '/klub', name: 'clubnike', component: Clubnike.ClubNikeNg };

/** Scratch Card */
export const SCRATCHCARD_DETAIL = {
    ...SCRATCHCARD_PATHS.DETAIL,
    component: ScratchCards.LotteryTicketDetail
};
export const SCRATCHCARD_KIOSK_LIST = {
    ...SCRATCHCARD_PATHS.KIOSK_LIST,
    component: ScratchCards.LotteryTicket
};
export const SCRATCHCARD_FAQ = {
    ...SCRATCHCARD_PATHS.FAQ,
    component: ScratchCards.LotteryTicket
};
export const SCRATCHCARD_PARTNER_ZONE = {
    ...SCRATCHCARD_PATHS.PARTNER_ZONE,
    component: ScratchCards.LotteryTicket
};
export const SCRATCHCARD_CONTACT = {
    ...SCRATCHCARD_PATHS.CONTACT,
    component: ScratchCards.LotteryTicket
};

export const SCRATCHCARD_I_SCRATCH = {
    ...SCRATCHCARD_PATHS.I_SCRATCH,
    component: ScratchCards.LotteryTicket
};

export const SCRATCHCARD_I_SCRATCH_PLAY = {
    ...SCRATCHCARD_PATHS.I_SCRATCH_PLAY,
    component: ScratchCards.LotteryTicket
};

export const SCRATCHCARD_OVERVIEW = {
    ...SCRATCHCARD_PATHS.OVERVIEW,
    component: ScratchCards.LotteryTicket
};

export const REKLAMACIA = { path: '/reklamacia/:hash', name: 'page::reklamacia', component: Reklamacia };

export const SEARCH_RESULTS = { path: '/vysledky-hladania/:searchText', name: 'searchResults', component: FullSearch };

const Offices = Loadable({ loader: imports.offices });

export const OFFICES = { path: '/mapa-pobociek', name: 'offices', component: Offices };
export const CONTACT_US_INFO = { path: '/kontakty', name: 'contactUsInfo', component: Contact };

export const COLLABORATION = {
    path: '/spolupraca',
    name: 'COLLABORATION',
    component: article('nike-spolupraca')
};
export const GAMING_PLANS = {
    path: '/herne-plany',
    name: 'GAMING_PLANS',
    component: article('herne-plany', LawMenu)
};

export const LICENSE = {
    path: '/licencie',
    name: 'LICENSE',
    component: article('licencie', LawMenu)
};

export const STAKING_AND_KLUB_NIKE_AGREEMENT = {
    path: '/zmluva-o-stavkovani-a-clenstve-v-klube-nike',
    name: 'STAKING_AND_KLUB_NIKE_AGREEMENT',
    component: article('zmluva-o-stavkovani-a-clenstve-v-klube-nike', LawMenu)
};

export const STAKING_AGREEMENT = {
    path: '/zavazne-podmienky-stavkovania-v-nike',
    name: 'STAKING_AGREEMENT',
    component: article('zavazne-podmienky-stavkovania-v-nike', LawMenu)
};

export const ANTI_SOCIAL_ACTIVITY = {
    path: '/protispolocenska-cinnost-info',
    name: 'ANTI_SOCIAL_ACTIVITY',
    component: article('protispolocenska-cinnost-info', LawMenu)
};

export const LEGAL_INFO = {
    path: '/pravidla-ochrany-osobnych-udajov',
    name: 'LEGAL_INFO',
    component: article('pravidla-ochrany-osobnych-udajov', LawMenu)
};

export const MARKETING_TOOLS = {
    path: '/osobitne-marketingove-nastroje-hazardnej-hry',
    name: 'MARKETING_TOOLS',
    component: article('osobitne-marketingove-nastroje-hazardnej-hry', LawMenu)
};

export const CHAT = { path: '/napiste-nam/chat', name: 'chat', component: Contact };
export const CONTACT_US = { path: '/napiste-nam', name: 'contactUs', component: Contact };
export const CHANGE_PHONE_NUMBER = {
    path: '/zmena-telefonneho-cisla',
    name: 'changePhoneNumber',
    component: ChangePhoneNumber
};

export const NOTIFIED_MATCHES = {
    path: '/upozornenia/zapasy',
    name: 'page::notifiedMatches',
    component: NotificationsPage
};
export const NOTIFIED_TICKETS = {
    path: '/upozornenia/tikety',
    name: 'page::notifiedTickets',
    component: NotificationsPage
};

export const LEGAL_INFO_ARTICLE = {
    path: '/info/pravne-informacie/:articleUrl',
    name: 'page::legalInfoArticle',
    component: LegalInformation
};
export const LEGAL_INFORMATION = {
    path: '/info/pravne-informacie',
    name: 'page::legalInformation',
    component: LegalInformation
};

export const HELP_ARTICLE = { path: '/info/:articleUrl', name: 'page::helpArticle', component: HelpArticles };
export const HELP_MENU = { path: '/info', name: 'page::helpMenu', component: HelpArticles };

export const OVERENIE_DOKLADOV = {
    path: '/clanok/overenie_dokladov',
    name: 'page::overenie_dokladov',
    component: article('overenie_dokladov')
};
export const KURZOVE_ZVYHODNENIE = {
    path: '/clanok/kurzove_zvyhodnenie',
    name: 'page::kurzove_zvyhodnenie',
    component: article('kurzove_zvyhodnenie')
};
export const INFORMATION_DUTY = {
    path: '/zodpovedne-hranie',
    name: 'articleInformationDuty',
    component: article('informacna-povinnost-2020', LawMenu)
};

export const POLEX_DOWNLOAD = {
    path: '/politicky-exponovana-osobnost-download',
    name: 'polexDownload',
    component: article('polex')
};
export const BLOCKED_BY_RVO = {
    path: '/zablokovany-pouzivatel-v-rvo',
    name: 'blocked-by-rvo',
    component: article('blocked-by-rvo')
};
export const RVO_UNAVAILABLE = {
    path: '/rvo-nedostupne',
    name: 'rvo-unavailable',
    component: article('rvo-unavailable')
};
export const MARKETING_ARTICLE = {
    path: '/clanky/:articleCode/:ignoreCache?',
    name: 'marketingArticle',
    component: ParamArticle
};

const PromoCmsLoadable = Loadable({ loader: imports.promoCms });

export const PROMO_CMS_TABLES = {
    path: PROMO_CMS_TABLES_PATH,
    name: 'page::promoCmsTables',
    component: PromoCmsLoadable
};

export const PROMO_CMS_SCHEDULE = {
    path: PROMO_CMS_SCHEDULE_PATH,
    name: 'page::promoCmsSchedule',
    component: PromoCmsLoadable
};

export const PROMO_CMS_BETS = {
    path: PROMO_CMS_BETS_PATH,
    name: 'page::promoCmsBets',
    component: PromoCmsLoadable
};

export const PROMO_CMS = {
    path: PROMO_CMS_ROOT_PATH,
    name: 'page::promoCms',
    component: PromoCmsLoadable
};

const TvNikeLoadable = Loadable({ loader: imports.tvnike });

export const LIVE_STREAMS = { path: '/zive-prenosy', name: 'page::liveStreams', component: TvNikeLoadable };
export const TV_NIKE_STREAM_DETAIL = {
    path: TV_NIKE_STREAM_DETAIL_PATH,
    name: 'page::nikeTVDetailPath',
    component: TvNikeLoadable
};
export const TV_NIKE_STREAM_OVERVIEW = {
    path: TV_NIKE_STREAM_OVERVIEW_PATH,
    name: 'page::nikeTV',
    component: TvNikeLoadable
};

export const TV_NIKE_ARCHIVE_DETAIL = {
    path: TV_NIKE_ARCHIVE_DETAIL_PATH,
    name: 'TV_NIKE_ARCHIVE_DETAIL',
    component: TvNikeLoadable
};

export const TV_NIKE_ARCHIVE_OVERVIEW = {
    path: TV_NIKE_ARCHIVE_OVERVIEW_PATH,
    name: 'TV_NIKE_ARCHIVE_OVERVIEW',
    component: TvNikeLoadable
};

export const TV_NIKE_HIGHLIGHTS_DETAIL = {
    path: TV_NIKE_HIGHLIGHTS_DETAIL_PATH,
    name: 'TV_NIKE_HIGHLIGHTS_DETAIL',
    component: TvNikeLoadable
};

export const TV_NIKE_HIGHLIGHTS_OVERVIEW = {
    path: TV_NIKE_HIGHLIGHTS_OVERVIEW_PATH,
    name: 'TV_NIKE_HIGHLIGHTS_OVERVIEW',
    component: TvNikeLoadable
};

export const MENU = { path: '/menu', name: 'page::menu', component: MainMenu };

const CasinoRoot = Loadable({ loader: imports.casinoVegas, exp: Exp => Exp.CasinoRoot });

export const CASINO_FAVORITE = { path: '/favorites/kasino', name: 'kasino:favorite', component: CasinoRoot };
export const CASINO_GAME_DETAIL = {
    path: CASINO_GAME_DESCRIPTION_PATH,
    name: 'kasino:game-detail',
    component: CasinoRoot
};
export const CASINO_CATEGORY_DETAIL = {
    path: CASINO_CATEGORY_PATH,
    name: 'kasino:category-detail',
    component: CasinoRoot
};
export const CASINO_HISTORY = { path: CASINO_HISTORY_PATH, name: 'casino:history', component: CasinoRoot };
export const I_SCRATCH_CARDS_HISTORY = {
    path: SCRATCHCARDS_HISTORY_PATH,
    name: 'i-scratch-cards:history',
    component: CasinoRoot
};
export const CASINO_HELP = { path: '/casino/technicka-podpora', name: 'kasino:help', component: CasinoRoot };
export const CASINO_MARKETING_ARTICLE = {
    path: CASINO_ARTICLE_PATH,
    name: 'casino:marketingArticle',
    component: CasinoRoot
};

export const CASINO_GAME_KASINO_CATEGORY = {
    path: CASINO_KASINO_CATEGORY_PATH,
    name: 'kasino:RedTiger:categorySlug',
    component: CasinoRoot
};

export const CASINO_GAME_HRY_CATEGORY = {
    path: CASINO_HRY_CATEGORY_PATH,
    name: 'kasino:iForium:categorySlug',
    component: CasinoRoot
};

export const CASINO_HRY_LOBBY = {
    path: CASINO_HRY_LOBBY_PATH,
    name: 'kasino:iForium:lobby',
    component: CasinoRoot
};

// export const CASINO_BONUS_CONDITIONS = {
//     path: '/casino/podmienky/:campaignCode',
//     name: 'kasino:bonusConditions',
//     component: CasinoRoot
// };
export const CASINO_GAME_ENDED = {
    path: '/casino/game-ended',
    name: 'CASINO_GAME_ENDED',
    component: CasinoRoot
};

export const CASINO_GAME = {
    path: CASINO_GAME_PLAY_PATH,
    name: 'kasino:game',
    component: CasinoRoot
};

// export const CASINO_BONUS = { path: '/casino/bonus-detail', name: 'kasino:bonus', component: CasinoRoot };
export const CASINO_LOBBY = { path: CASINO_KASINO_LOBBY_PATH, name: 'kasino:lobby', component: CasinoRoot };

const CommunityLoadable = Loadable({ loader: imports.betbook, exp: Exp => Exp.BetbookRoot });
const CommunityRoot = props => {
    return <CommunityLoadable {...props} />;
};
const TurboLiveLoadable = Loadable({ loader: imports.turboLive, exp: Exp => Exp.TurboLiveRoot });
const TurboLiveRoot = props => {
    return (
        <RequiresNikeone fallback={<ModuleFallback msg={'nui.module.missing.nikeone'} />}>
            <TurboLiveLoadable {...props} />
        </RequiresNikeone>
    );
};

export const TURBO_LIVE_MATCH_DETAIL = {
    path: TURBO_LIVE_MATCH_DETAIL_PATH,
    name: 'turboLive:detail',
    component: TurboLiveRoot
};

export const TURBO_LIVE_FAVORITES = {
    path: TURBO_LIVE_FAVORITE_PATH,
    name: 'turboLive:favorites',
    component: TurboLiveRoot
};

export const TURBO_LIVE_SPORT = {
    path: TURBO_LIVE_SPORT_PATH,
    name: 'turboLive:sport',
    component: TurboLiveRoot
};

export const COMMUNITY_CONDITIONS = {
    ...COMMUNITY_PATHS.COMMUNITY_CONDITIONS,
    component: CommunityRoot
};

export const COMMUNITY_FAQ = {
    ...COMMUNITY_PATHS.COMMUNITY_FAQ,
    component: CommunityRoot
};

export const COMMUNITY_NEW_ANALYSIS_FROM_TICKET = {
    ...COMMUNITY_PATHS.COMMUNITY_NEW_ANALYSIS_FROM_TICKET,
    component: CommunityRoot
};
export const COMMUNITY_NEW_ANALYSIS = {
    ...COMMUNITY_PATHS.COMMUNITY_NEW_ANALYSIS,
    component: CommunityRoot
};
export const COMMUNITY_EDIT_ANALYSIS = {
    ...COMMUNITY_PATHS.COMMUNITY_EDIT_ANALYSIS,
    component: CommunityRoot
};
export const COMMUNITY_ANALYSIS_DETAIL = {
    ...COMMUNITY_PATHS.COMMUNITY_ANALYSIS_DETAIL,
    component: CommunityRoot
};
export const COMMUNITY_ANALYSES = {
    ...COMMUNITY_PATHS.COMMUNITY_ANALYSES,
    component: CommunityRoot
};

export const COMMUNITY_NEW_TICKET_FROM_TICKET_HASH = {
    ...COMMUNITY_PATHS.COMMUNITY_NEW_TICKET_FROM_TICKET_HASH,
    component: CommunityRoot
};
export const COMMUNITY_NEW_TICKET = {
    ...COMMUNITY_PATHS.COMMUNITY_NEW_TICKET,
    component: CommunityRoot
};
export const COMMUNITY_EDIT_TICKET = {
    ...COMMUNITY_PATHS.COMMUNITY_EDIT_TICKET,
    component: CommunityRoot
};
export const COMMUNITY_TICKET_DETAIL = { ...COMMUNITY_PATHS.COMMUNITY_TICKET_DETAIL, component: CommunityRoot };
export const BETBOOK_TICKETS = {
    ...COMMUNITY_PATHS.COMMUNITY_TICKETS,
    component: CommunityRoot
};

export const COMMUNITY_POSTS_AUTHOR = {
    ...COMMUNITY_PATHS.COMMUNITY_POSTS_AUTHOR,
    component: CommunityRoot
};

export const COMMUNITY_TOP_EVENTS = {
    ...COMMUNITY_PATHS.COMMUNITY_TOP_EVENTS,
    component: CommunityRoot
};

export const COMMUNITY_LOBBY = { ...COMMUNITY_PATHS.COMMUNITY_LOBBY, component: CommunityRoot };

const GoalOfMonthPageLoadable = Loadable({ loader: imports.goalOfMonthPage });

export const GOAL_OF_MONTH = {
    ...GOAL_OF_MONTH_PATHS.GOAL_OF_MONTH,
    component: GoalOfMonthPageLoadable
};

const FondComponent = article('fond-pre-buducnost-sportu');
export const FOND_PRE_BUDUCNOST_SPORTU = {
    path: '/fond-pre-buducnost-sportu',
    name: 'fondPreBuducnostSportu',
    component: FondComponent
};

export const ABOUT_US = {
    path: '/o-nas',
    name: 'ABOUT_US',
    component: article('o-nas')
};

export const FOR_PLAYERS = {
    path: '/pre-hracov',
    name: 'FOR_PLAYERS',
    component: () => <ArticleMenu menu={ForPlayersMenu} />
};

export const BETS_LIST = {
    path: '/kurzovy-list',
    name: 'BETS_LIST',
    component: article('kurzovy-list', ForPlayersMenu)
};

export const PAYMENT_METHODS = {
    path: '/platobne-metody',
    name: 'PAYMENT_METHODS',
    component: article('platobne-metody', ForPlayersMenu)
};

export const HELP = {
    path: '/vysvetlivky',
    name: 'HELP',
    component: article('napoveda', ForPlayersMenu)
};

export const BETTING_VIA_SMS = {
    path: '/tipovanie-cez-sms',
    name: 'BETTING_VIA_SMS',
    component: article('tipuj-cez-sms', ForPlayersMenu)
};

export const BONUSES = {
    path: '/bonusy',
    name: 'BONUSES',
    component: article('bonusy', BonusesMenu)
};

export const BONUSES_BETTING = {
    path: '/bonusy-tipovanie',
    name: 'BONUSES_BETTING',
    component: article('bonusy-tipovanie', BonusesMenu)
};

export const BONUSES_AKV = {
    path: '/vstupne-bonusy',
    name: 'BONUSES_AKV',
    component: article('vstupne-bonusy', BonusesMenu)
};

export const LAW = {
    path: '/pravne-informacie',
    name: 'LAW',
    component: article('pravne-informacie', LawMenu)
};

export const GAME_FOR_NIKY = {
    path: '/hra-za-niky',
    name: 'GAME_FOR_NIKY',
    component: article('hra-za-niky')
};

export const REGISTRATION_BONUSES = {
    path: '/vstupne-bonusy',
    name: 'REGISTRATION_BONUSES',
    component: article('vstupne-bonusy')
};

export const ACCOUNT_CANCEL = {
    path: '/zrusenie-konta',
    name: 'accountCancelRequest',
    component: AccountCancelRequest
};

export const CHAT_NEW_MESSAGE = { path: '/chat/nova-sprava', name: 'chat:newMessage', component: Chat };
export const CHAT_NEW_MESSAGE_WITH_PARAMS_ID = {
    path: '/chat/nova-sprava/?analysisId=:analysisId',
    name: 'chat:newMessage',
    component: Chat
};
export const COMMUNITY_CHAT = { path: '/chat', name: 'community:chat', component: Chat };

const ArticleArchiveLoadable = Loadable({ loader: imports.articleArchive });

export const ARTICLE_ARCHIVE = {
    ...ARTICLE_ARCHIVE_PATHS.ARTICLES,
    component: ArticleArchiveLoadable
};
export const LOGIN = { path: '/:loginpath(prihlasenie|prihlasenie-sa)', name: 'login', component: LoginPage };

export const HOME = { path: '/', name: 'page::home', component: HomePage };

/**
 ************************
 * ROUTE ORDER MATTERS! *
 ************************
 */
